// extracted by mini-css-extract-plugin
export var infoItem = "_oq-2";
export var title = "_oq-0";
export var value = "_oq-1";